/* eslint-disable no-param-reassign,no-underscore-dangle,no-console */

// https://github.com/LinusBorg/vue-directive-clickout/blob/develop/src/index.js

function isVisible(el) {
  const { display, visibility } = window ? window.getComputedStyle(el) : {};
  return display !== 'none' && visibility !== 'hidden';
}

const directive = {
  mounted(el, binding) {
    // Provided expression must evaluate to a function.
    if (import.meta.env.DEV && typeof binding.value !== 'function') {
      console.warn(`[Vue-clickout:] provided expression '${binding.expression}' is not a function, but has to be`);
    }

    // Define Handler and cache it on the element
    const bubbleMod = binding.modifiers.bubble;
    const visibleMod = binding.modifiers.visible;
    const handler = e => {
      const targetOk = bubbleMod || (!el.contains(e.target) && el !== e.target);
      const visibilityOk = !visibleMod || isVisible(el);
      if (targetOk && visibilityOk) {
        binding.value(e);
      }
    };
    el.__vueClickout__ = handler;

    // add Event Listeners
    document.addEventListener('click', handler);
  },

  unmounted(el) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickout__);
    el.__vueClickout__ = null;
  },
};

export { directive as default };
